module.exports = __webpack_public_path__ + "img/12.fbf3396d.jpg";